(window.styleExpertsButtons = function ($, Behaviors) {

  "use strict";
  
  function styleExpertsButtons(elem) {
    Behaviors.init(styleExpertsButtons, this, arguments);

    let btnLiveChat = document.querySelector('#hero-se-2'),
        btnLiveChat2 = document.querySelector('#hero-se-3');

    btnLiveChat.addEventListener('click', function(e){
      let iframe = document.querySelector('#chat-button');
      let button = iframe.contentDocument.querySelector('#gorgias-chat-messenger-button');
      e.preventDefault();
      button.click();
    });

    btnLiveChat2.addEventListener('click', function(e){
      let iframe = document.querySelector('#chat-button');
      let button = iframe.contentDocument.querySelector('#gorgias-chat-messenger-button');
      e.preventDefault();
      button.click();
    });
  }

  Behaviors.inherit(styleExpertsButtons, Behaviors.Behavior);
  styleExpertsButtons.QUERY = '.hero-se';

  Behaviors.register_behavior(styleExpertsButtons);
  
  return styleExpertsButtons;

  }(window.jQuery, window.Behaviors));